import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './LatestProperties.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Sample data for properties
const properties = [
  { id: 1, image: '/image/card1.jpg', title: 'New Villas', distance: '26 miles away', bedrooms: 4, bathrooms: 5, area: '2,560 sqft' },
  { id: 2, image: '/image/card2.jpg', title: 'Countryside House', distance: '34 miles away', bedrooms: 4, bathrooms: 3, area: '2,080 sqft' },
  { id: 3, image: '/image/card3.jpg', title: 'Modern Apartment', distance: '12 miles away', bedrooms: 2, bathrooms: 2, area: '1,200 sqft' },
  { id: 4, image: '/image/card4.jpg', title: 'Beachside Bungalow', distance: '5 miles away', bedrooms: 3, bathrooms: 2, area: '1,800 sqft' },
  { id: 5, image: '/image/card5.jpg', title: 'Mountain Cabin', distance: '50 miles away', bedrooms: 1, bathrooms: 1, area: '900 sqft' },
];

const LatestProperties = () => (
  <div className="container my-5" id="latest-properties">
    <h2 className="text-center mb-2">Latest Properties</h2>
    <p className="text-center text-muted mb-4">
      Our website aims to provide a seamless and user-friendly experience for individuals and families searching for their dream home.
    </p>

    <Swiper
      className="latest-properties-swiper"
      modules={[Pagination, Autoplay]}
      pagination={{ clickable: true }}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      spaceBetween={20}
      breakpoints={{
        0: { slidesPerView: 1, spaceBetween: 15 },
        480: { slidesPerView: 1.3, spaceBetween: 15 },
        768: { slidesPerView: 1.7, spaceBetween: 20 },
        992: { slidesPerView: 2.3, spaceBetween: 25 },
        1200: { slidesPerView: 3, spaceBetween: 30 },
      }}
    >
      {properties.map(prop => (
        <SwiperSlide key={prop.id}>
          <div id='card' className=" latest-property-card">
            <img
              src={prop.image}
              alt={prop.title}
              className="latest-property-image"
              loading="lazy"
            />
            <div className="latest-property-content">
              <h5 className="card-title">{prop.title}</h5>
              <p className="latest-property-distance">{prop.distance}</p>
              <div className="latest-property-details">
                <div><i className="bi bi-door-closed-fill"></i> {prop.bedrooms}</div>
                <div><i className="bi bi-bathtub-fill"></i> {prop.bathrooms}</div>
                <div><i className="bi bi-rulers"></i> {prop.area}</div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
);


export default LatestProperties;
